import { DrawerActionBar, type DrawerActions } from '@openx/components-core/lib/Drawer/DrawerActionBar.tsx';
import { DrawerHeader } from '@openx/components-core/lib/Drawer/DrawerHeader.tsx';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { BrandsSection } from './sections/Brands.tsx';
import { ContentAttributesSection } from './sections/ContentAttributes.tsx';
import { CreativeTypesSection } from './sections/CreativeTypes.tsx';
import { IndustrySection } from './sections/Industry.tsx';
import { LanguagesSection } from './sections/Languages.tsx';
import { LeanFiltersSection } from './sections/LeanFilters.tsx';

interface SupplementalAdQualityFormProps {
  onCancel: () => void;
  onSubmit: () => void;
}

export function SupplementalAdQualityForm(props: SupplementalAdQualityFormProps) {
  const { onSubmit, onCancel } = props;
  const { t } = useTranslation();

  const actions: DrawerActions = useMemo(
    () => [
      {
        color: 'primary',
        label: t('Apply'),
        onClick: onSubmit,
      },
      {
        label: t('Cancel'),
        onClick: onCancel,
        variant: 'text',
      },
    ],
    [onCancel, onSubmit, t]
  );

  return (
    <div data-test="side-details">
      <DrawerHeader onClose={onCancel}>{t('Supplemental Ad Quality Filters')}</DrawerHeader>

      <IndustrySection />
      <BrandsSection />
      <ContentAttributesSection />
      <CreativeTypesSection />
      <LanguagesSection />
      <LeanFiltersSection />

      <DrawerActionBar actions={actions} stickyBottom hideDivider />
    </div>
  );
}
